import { KeyValue } from '@delmonicos/shared-design-system-react/src/components/filter-selector/filter-selector';
import { FilterToggle } from '@delmonicos/shared-design-system-react/src/components/filter-toggle/filter-toggle';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import { Picto } from '@delmonicos/shared-design-system-react/src/components/picto/picto';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { ChargePointStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/enums/charge-point-status.enum';
import { useTranslation } from 'react-i18next';

import { mapStatusToGenericConnectorStatus } from '@app/feature/charge-point/helper/connector-status.helper';

const unfilterableStatusList = new Set([
  ChargePointStatus.SuspendedEV,
  ChargePointStatus.Finishing,
  ChargePointStatus.Reserved,
]);

interface ChargePointChannelOcppStatusFilterControllerProps {
  onChange: (itemIds: string[]) => void;
  selectedItemIds: string[];
}

export const ChargePointChannelOcppStatusFilterController = ({
  onChange,
  selectedItemIds,
}: ChargePointChannelOcppStatusFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const channelStatus = Object.values(ChargePointStatus)
    .map((status) => ({
      key: status,
      value: t(
        `delmonicos-shared-sdk.ocpp-enums-charge-point-status.${status}`,
      ),
    }))
    .filter((i) => !unfilterableStatusList.has(i.key));

  const iconRender = (item: KeyValue) => (
    <Picto
      name={
        mapStatusToGenericConnectorStatus(item.key as ChargePointStatus).picto
      }
    />
  );

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="electric-terminal"
        text={t('delmonicos-shared-sdk.outputs-physical-socket.ocpp-status')}
      />
      <FilterToggle
        iconRender={iconRender}
        initialSelectedItemIds={selectedItemIds}
        items={channelStatus}
        onChange={onChange}
      />
    </Stack>
  );
};
